export enum InterestType {
    Country = 'country',
    Discipline = 'discipline',
}
